import type { PokerGameTileAttribute } from '@ps/poker-games-tile-mappers';
import { AttributeKey } from '@ps/poker-games-tile-mappers';
import { useIntl } from 'react-intl';

import { TXTCLI_Table_Size } from './useArrangeAttributes.messages.json';

export default (attributes: PokerGameTileAttribute[], maxPlayers: number) => {
  const { formatMessage } = useIntl();

  const topSectionItems = attributes.filter(
    ({ key }) =>
      key === AttributeKey.startTime ||
      key === AttributeKey.startsIn ||
      key === AttributeKey.running ||
      key === AttributeKey.lateReg
  );
  const bottomSectionItems = attributes.filter(
    ({ key }) =>
      key === AttributeKey.ante ||
      key === AttributeKey.buyIn ||
      key === AttributeKey.buttonBlind ||
      key === AttributeKey.prizePool ||
      key === AttributeKey.freeRoll ||
      key === AttributeKey.players ||
      key === AttributeKey.seat ||
      key === AttributeKey.stakes ||
      key === AttributeKey.winUpTo
  );
  const [first, ...rest] = bottomSectionItems;
  const playersAttribute = {
    value: `${maxPlayers}`,
    key: AttributeKey.players,
    name: formatMessage(TXTCLI_Table_Size)
  };

  return {
    topSectionItems,
    bottomSectionItems: [first, playersAttribute, ...rest]
  };
};
